module.exports = __webpack_public_path__ + "static/media/B_S01.45c5d2c8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/RED/B_S01.png
// module id = 118
// module chunks = 0